import type {BreakdownRow} from '@/services/experienceScore/mappings/metricMapping';

import BreakdownListRow from './BreakdownListRow';

interface BreakdownListProps {
    rows: BreakdownRow[];
    learnMoreLabel?: string;
    onRowButtonClick: (row: BreakdownRow) => void;
}

const BreakdownList = ({rows, learnMoreLabel, onRowButtonClick}: BreakdownListProps) => (
    <ul className='flex flex-col divide-y divide-primary/10 rounded-xl bg-light-silver px-4 dark:divide-romance/10 dark:bg-orion-tile'>
        {rows.map((row) => (
            <BreakdownListRow
                key={row.label}
                row={row}
                learnMoreLabel={learnMoreLabel}
                onRowButtonClick={onRowButtonClick}
            />
        ))}
    </ul>
);

export default BreakdownList;
